import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

@Injectable()
export class LoginService {

  private loginUrl = globals.APIURL + '/login'; // TODO!!! Change this when going live

    constructor (private http: Http, public authHttp: AuthHttp) {
    }

    postLogin(): Observable<string> {
      console.log('postLogin service called');
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({ body: '', headers: headers });

      return this.authHttp.get(this.loginUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
    }

    private extractData(res: Response) {
      let body = res.json();
      // console.log('BODY:', body);
      return body || { };
    }

    handleError(error: any) {
      // In a real world app, we might use a remote logging infrastructure
      // We'd also dig deeper into the error to get a better message
      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
      return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/login/login.service.ts